export default __webpack_public_path__ + "static/charts-8c8601cf4e1355a0966c86b5e1196edf.png";